import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/aios.png"

export function Index() {
  return (
    <Layout
      title="AIOC Kochi Medical Conference Photo Management with Premagic AI-DAM"
      description="How All India Ophthalmological Conference solved photo management challenges through Premagic’s AI-powered Digital Asset Management solution."
      metaImage={ThumbnailImage}
      keywords={[
        "AIOC case study, medical conference photos, ophthalmology event technology, healthcare conference management, medical event photo sharing, doctor conference networking, medical conference technology, healthcare event solutions, physician networking events, medical association events, healthcare photo management, doctor conference photos, medical event marketing, healthcare digital solutions, medical conference automation",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "AIOC Kochi", url: "/case-study/aioc/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "AIOC Kochi Medical Conference Photo Management with Premagic AI-DAM",
            "description": "How All India Ophthalmological Conference solved photo management challenges through Premagic’s AI-powered Digital Asset Management solution.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.AIO} />
    </Layout>
  )
}

export default Index
